import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {addNotification} from '../../redux/actions';
import {createCompanyBudget, updateCompanyBudget} from '../../redux/actions/companiesBudgets';
import AppDialog from '../../components/AppDialog';
import {Box, DialogContent, DialogTitle, FormControl, Grid, Typography, TextField} from '@material-ui/core';
import {makeStyles} from '@material-ui/core';
import {ErrorMessage, Form, Formik} from 'formik';
import * as yup from 'yup';
import AppButton from '../../components/AppButton';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  title: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(2),
  },
  map: {
    height: 215,
    width: '100%',
    position: 'relative',
  },
  textField: {
    width: '100%',
  },
  formControl: {
    width: '100%',
  },
}));

const validation = yup.object().shape({
  cost_center: yup
    .string()
    .required('El campo centro de costo es requerido.'),
  major_account: yup
    .string()
    .required('El campo cuenta mayor es requerido.'),
  budget: yup.string().required('El campo presupuesto es requerido.'),
});

export default function BudgetCreate(props) {
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const {dataEdit} = props;

  const dispatch = useDispatch();
  const classes = useStyles();

  function save({id, ...values}) {
    setLoading(true);
    if (dataEdit?.id) {
      dispatch(updateCompanyBudget(id, values))
        .then(() => {
          dispatch(addNotification('Presupuesto editado', 'success'));
        })
        .catch((e) => {
          dispatch(addNotification(e.message, 'error'));
        })
        .finally(() => {
          setLoading(false);
          props.handleClose();
        });
    } else {
      dispatch(createCompanyBudget(values))
        .then(() => {
          dispatch(addNotification('Presupuesto guardado', 'success'));
        })
        .catch((e) => {
          dispatch(addNotification(e.message, 'error'));
        })
        .finally(() => {
          setLoading(false);
          props.handleClose();
        });
    }
  }

  useEffect(() => {
    if (dataEdit?.id) setInitialValues(dataEdit);
    else setInitialValues({});
  }, [dataEdit]);

  return (
    <AppDialog maxWidth={480} {...props}>
      <DialogTitle className={classes.title}>{dataEdit?.id ? 'Actualizar' : 'Agregar'} presupuesto</DialogTitle>
      <DialogContent>
        <Box mb={3} px={2} clone>
          <Formik
            initialValues={initialValues}
            validationSchema={validation}
            enableReinitialize
            onSubmit={save}
            render={({values, handleChange, handleSubmit}) => (
              <Form
                onKeyPress={(event) => {
                  event.key === 'Enter' && handleSubmit();
                }}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <Box mb={2}>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <Typography variant="body2">Centro de costo</Typography>
                        <TextField
                          variant="outlined"
                          name="cost_center"
                          value={values.cost_center}
                          onChange={handleChange}
                          className={classes.textField}
                          margin="dense"
                        />
                        <ErrorMessage
                          name="cost_center"
                          render={(msg) => <div style={{color: 'red', fontWeight: 400}}>{msg}</div>}
                        />
                      </FormControl>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <Typography variant="body2">Cuenta mayor</Typography>
                        <TextField
                          variant="outlined"
                          name="major_account"
                          value={values.major_account}
                          onChange={handleChange}
                          className={classes.textField}
                          margin="dense"
                        />
                        <ErrorMessage
                          name="major_account"
                          render={(msg) => <div style={{color: 'red', fontWeight: 400}}>{msg}</div>}
                        />
                      </FormControl>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <Typography variant="body2">Presupuesto</Typography>
                        <TextField
                          variant="outlined"
                          name="budget"
                          value={values.budget}
                          onChange={handleChange}
                          className={classes.textField}
                          margin="dense"
                        />
                        <ErrorMessage
                          name="budget"
                          render={(msg) => <div style={{color: 'red', fontWeight: 400}}>{msg}</div>}
                        />
                      </FormControl>
                    </Box>
                    <Box display="flex" justifyContent="center" mb={2}>
                      <AppButton
                        size="large"
                        onClick={handleSubmit}
                        loading={loading}
                        round
                        disableElevation
                        variant="contained"
                        color="secondary"
                      >
                        {dataEdit.id ? 'Actualizar' : 'Agregar'} presupuesto
                      </AppButton>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            )}
          ></Formik>
        </Box>
      </DialogContent>
    </AppDialog>
  );
}
